import React, { Component, useEffect, useState } from "react";
import { Menu, Icon } from "antd";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
// import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";
import { fetchUser, getData } from '../../util/API'
import { message } from "antd/lib/index";
import { fetchUserInfo, actionsCount } from '../../appRedux/actions/Auth'

const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;

const createNew = () => {
  localStorage.removeItem("uuid");
}
const SidebarContentComp = (props) => {
  //console.log(props,'finace props....!')
  const { action_count } = useSelector(({ auth }) => auth);
  const [task_count, setTaskCount] = useState(0);
  const handleClick = e => {
    // console.log('click ', e);
  };
  let { navStyle, themeType } = useSelector(({ settings }) => settings);
  // console.log(navStyle, 'navvvvvvvvv/vv', themeType)
  let { pathname } = useSelector(({ common }) => common);
  // console.log("pathname => ", pathname)

  const fetchTasks = () => {
    let endpoint = '/finance/task-count/'
    getData(endpoint)
      .then(res => {
        if (res.data) {

          localStorage.setItem('task_count', res.data.task_count);
          setTaskCount(localStorage.getItem('task_count'));
        }
        else {
          // this.props.dispatch(actionsCount(0))
          // this.setState({count: 0});
          // return 0;
        }
      }).catch(error => {
        // this.props.dispatch(actionsCount(0))
        console.log('error', error)
      });
  }

  useEffect(() => {
    fetchTasks()
    // setInterval(() =>  fetchTasks(), 100000)
  }, [pathname])
  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  const selectedKeys = pathname.substr(1);
  // console.log("selectedKeys -> ", selectedKeys)
  const defaultOpenKeys = selectedKeys.split('/')[0];

  let user = props.user.data
  if (!user) {
    return (
      <></>
    )
  }

  let info = user['LogedInUserInfo']

  // const user_role = info.user_role ? info.user_role:""
  const user_role = localStorage.getItem('user_role')
  // const user_role = "accountant"
  // const status = info.status? info.status:"pending"
  // const myprofile_link = '/detail/'.concat(info.uuid)

  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile info={info} />
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            onClick={handleClick()}
            defaultOpenKeys={[defaultOpenKeys, '']}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline">
            {(user_role === 'finance_user' && user_role !== 'client_invoicer') && <Menu.Item key="add-client-costcentre">
              <Link to="/add-client-costcentre" >
                {/* <Icon type="account-book" /> */}
                <i className="icon icon-contacts" />
                <span>Add Client/Cost Centre</span>
              </Link>
            </Menu.Item>}
            {(user_role !== 'payable_partner_user'&& user_role !== 'client_invoicer')   && <Menu.Item key="finance">
              <Link to="/finance">
                <i className="icon icon-editor" />
                <span>Verify KYC</span>
              </Link>
            </Menu.Item>}
            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <Menu.Item key="invoice-request">
              <Link to="/invoice-request">
                {/* <Icon type="snippets" /> */}
                <i className="icon icon-attachment" />
                <span>Invoice Request</span>
              </Link>
            </Menu.Item>}

            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <SubMenu key="partner-invoice" popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<span> <i className="icon icon-user" />

                <span>Partner Invoice</span></span>}>

              <Menu.Item key="partner-invoice">
                <Link to="/partner-invoice">
                  <i className="icon icon-add-circle" />
                  <span>Add Invoice</span>
                </Link>
              </Menu.Item>
              {user_role === 'finance_user' && <Menu.Item key="partner-invoice-review">
                <Link to="/partner-invoice-review">
                  <i className="icon icon-check" />
                  <span>Verify Invoice</span>
                </Link>
              </Menu.Item>}
            </SubMenu>}

            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <SubMenu key="transactions" popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<span> <i className="icon icon-revenue-new" />

                <span> Transactions</span></span>}>
              <Menu.Item key="tpp-transactions">
                <Link to="/tpp-transactions">
                  <i className="icon icon-orders" />
                  <span>TPP Transactions</span>
                </Link>
              </Menu.Item>
              {user_role === 'finance_user' && <Menu.Item key="payables">
                <Link to="/payables">
                  <i className="icon icon-translation" />
                  <span>Payables</span>
                </Link>
              </Menu.Item>}
              {user_role === 'finance_user' && <Menu.Item key="paid-invoices">
                <Link to="/paid-invoices">
                  <i className="icon icon-listing-dbrd" />
                  <span>Paid Invoice List</span>
                </Link>
              </Menu.Item>}

            </SubMenu>}
            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <SubMenu key="client-data" popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<span> <i className="icon icon-profile2" />
                <span>Client Data</span></span>}>
              <Menu.Item key="client-purchase-order">
                <Link to="/client-purchase-order">
                  <i className="icon icon-feedback" />
                  <span>Client PO</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="client-invoice">
                <Link to="/client-invoice">
                  <i className="icon icon-feedback" />
                  <span>Client Invoice</span>
                </Link>
              </Menu.Item>

              {user_role === 'finance_user' && <Menu.Item key="client-invoice-review">
                <Link to="/client-invoice-review">
                  <i className="icon icon-feedback" />
                  <span>Invoice Review</span>
                </Link>
              </Menu.Item>
              }

            </SubMenu>}

            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <Menu.Item key="partner-collections">
              <Link to="/partner-collections">
                <i className="icon icon-tickets" />
                <span>Partner Collections</span>
              </Link>
            </Menu.Item>}

            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <Menu.Item key="deposits-refunds">
              <Link to="/deposits-refunds">
                <i className="icon icon-revenue-new" />
                <span>Deposits and Refunds</span>
              </Link>
            </Menu.Item>}


            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <Menu.Item key="actions">
              <Link to="/actions">
                <i className="icon icon-data-entry" />
                <span>Actions  </span> <span className="gx-bg-danger gx-rounded-circle gx-badge gx-text-white">{task_count}</span>
              </Link>
            </Menu.Item>}

            {(user_role !== 'payable_partner_user' && user_role !== 'client_invoicer')  && <Menu.Item key="finance-export-import">
              <Link to="/finance-export-import">
                <i className="icon icon-transfer" />
                <span>Exports/Imports</span>
              </Link>
            </Menu.Item>}

            {(user_role === 'finance_user' && user_role !== 'client_invoicer') &&

              <Menu.Item key="finance-dashboard">
                <Link to="/finance-dashboard">
                  <i className="icon icon-data-display" />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>}
            {(user_role === 'payable_partner_user' && user_role !== 'client_invoicer') &&

              <Menu.Item key="invoice-list">
                <Link to="/invoice-list">
                  <i className="icon icon-data-display" />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>}
            {user_role === 'client_invoicer' && <Menu.Item key="client-invoices">
              <Link to="/client-invoices" >
                {/* <Icon type="account-book" /> */}
                <i className="icon icon-contacts" />
                <span>Client Invoice</span>
              </Link>
            </Menu.Item>}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};
// const fetchTasks = (props) => {

//   let endpoint = '/finance/task-count'
//   getData(endpoint)
//       .then(res => {
//           if (res.data.task_count) {
//                 props.dispatch(actionsCount(res.data.task_count))

//           }
//           else {
//             props.dispatch(actionsCount(0))
//           }
//       }).catch(error => {
//           props.dispatch(actionsCount(0))
//           console.log('error', error)
//       });
// }


class FinanceSidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: "",
    };
    this.getUserDetails()
  }


  getUserDetails = () => {
    fetchUser()
      .then(res => {
        if (res.data['status'] === 200) {
          this.setState({ cloader: false, userData: res });
          this.props.dispatch(fetchUserInfo(res['data']['LogedInUserInfo']))
        } else {
          this.setState({ cloader: false });
          message.error("Something went wrong ! please try again.")
        }
      })
      .catch(error => {
        this.setState({ cloader: false });
        // message.error(error.toString())
      });
  }

  render() {
    return (
      <SidebarContentComp user={this.state.userData} />
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser, action_count } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser, action_count }
};


SidebarContentComp.propTypes = {};
export default connect(mapStateToProps,)(FinanceSidebarContent);
